import React from "react";
import Search from "../../components/search";
import Image from "../../asset/img/banner/dashboard-view-laptop-2.webp";
// import Video from "../../asset/vid/save-protect-against-cybercrime.mp4";
import DetectDevice from "../../utils/detectDevice";
import './style.css';

const HeroSlider = () => {
  const {mobile, desktop} = DetectDevice();
  const [fS, setFS] = React.useState(3);
  const [lH, setLH] = React.useState(1.2);
  const [paddingVal, setPaddingVal] = React.useState(200);
  const [offsetHeight, setOffsetHeight] = React.useState(0);
  // const bannerHeight = document.querySelector("#hero-section").offsetHeight;
  
  React.useEffect(() => {
    mobile ? setFS(3) : setFS(4.3);
    mobile ? setLH(1.2) : setLH(1);
    mobile ? setPaddingVal(100) : setPaddingVal(200);
    mobile ? setOffsetHeight(0) : setOffsetHeight(600);
  }, [mobile]);
  
  return (
    <>
      <div id="hero-section" className="d-flex flex-column flex-lg-row align-items-center">
        <div className="col-12 col-lg-6 pe-0 pe-lg-5 z-2">
          <div className="hero-caption container text-center text-lg-start
            d-flex flex-column justify-content-center 
            align-items-center align-items-lg-start"
            style={{ 
              paddingTop: paddingVal,
              paddingBottom: paddingVal,
            }}>
            <div className="text-lg-start text-center text-pre-header">Revolutionary 360 Degree</div>
            <div className="text-header"
              style={{
                fontSize: `${fS}rem`,
                lineHeight: `${lH}`,
              }}>Vulnerability Assessment & Remediation</div>
            <div className="text-subheader">Guard And Defend Your Cyber Security Estate With Real-Time Data Leveraging The Power Of Machine Learning</div>
            <a 
              href="https://vulnerabilityassessmenttool.com/save/demo"
              className="btn-trial text-center my-4 mt-5 text-decoration-none">Book a Demo
            </a>
          </div>
        </div>
        {desktop &&
          <>
            <div className="col-12 col-lg-6 p-5 z-2">
              <Search />
            </div>            
          </>
        }
      </div>
      <div id="hero-section-image"
        className="col-12 col-lg-6 position-absolute align-items-center top-0 end-0 z-1"
        style={{paddingTop: paddingVal}}>
        <img src={Image} alt=""
          className="pt-5 pb-5"
          style={{ 
            // width: "100%",
            height: offsetHeight,
            opacity: 0.6,
          }}
        />
      </div>
    </>
  );
};

export default HeroSlider;